export default __webpack_public_path__ + "static/media/puzzle3.66dd0fa7.svg";